"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const fi_1 = require("react-icons/fi");
const ActionButtons = ({ onEdit, onDelete }) => {
    return (react_1.default.createElement(material_1.Stack, { direction: "row" },
        react_1.default.createElement(material_1.IconButton, { "aria-label": "edit-button", onClick: onEdit },
            react_1.default.createElement(fi_1.FiEdit, { color: "#333", fontSize: "small" })),
        react_1.default.createElement(material_1.IconButton, { "aria-label": "delete-button", onClick: onDelete },
            react_1.default.createElement(fi_1.FiTrash, { color: "#333", fontSize: "small" }))));
};
exports.default = ActionButtons;
